import React from 'react';
import useCounter from '../hooks/useCounter';

function About() {
  useCounter('.timer', {
    threshold: 0.5,
    rootMargin: '0px'
  });

  return (
    <>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>About Us</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="welcome-4 page-section-ptb white-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span className="justify-content-center">Welcome to</span>
                <h2 className="justify-content-center">the key valet parking service</h2>
                <div className="separator justify-content-center"></div>
                <p style={{textAlign: 'justify'}}>The Key Valet Parking Service is based in Doha, Qatar, provides premium valet parking solutions for hotels, corporate venues, events, and private properties. 
                  <br />
                  Our focus beyond parking cars, we prioritize trust, efficiency and an exceptional guest experience.
                  <br />
                  Each vehicle is carefully handled by our trained team, ensuring safety, punctuality, and professionalism from drop-off to pickup.
                  <br />
                  Trusted by hundreds of clients across Qatar, we deliver seamless, organized, and reliable valet operations tailored to every event or property.
                  <br />
                  With The Key, you can rely on smooth coordincation, attentive service, and peace of mind for your guest and clients.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="feature-box text-center">
                <div className="icon">
                  <i className="glyph-icon flaticon-beetle"></i>
                </div>
                <div className="content">
                  <h6>VIP Service</h6>
                  <p className="mb-0">Priority parking and personalized handling for high-profile guests and clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="feature-box text-center">
                <div className="icon">
                  <i className="glyph-icon flaticon-interface-1"></i>
                </div>
                <div className="content">
                  <h6>Safe Parking</h6>
                  <p className="mb-0">Vehicles are parked in secure, monitored areas with full accountability.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="feature-box text-center">
                <div className="icon">
                  <i className="glyph-icon flaticon-mechanic"></i>
                </div>
                <div className="content">
                  <h6>Trained Staff</h6>
                  <p className="mb-0">Professionally dressed and well-trained team ensures smooth guest experience.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="feature-box text-center">
                <div className="icon">
                  <i className="glyph-icon flaticon-wallet"></i>
                </div>
                <div className="content">
                  <h6>Time Saving</h6>
                  <p className="mb-0">No more searching for parking—drop your keys and we handle the rest.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="counter counter-style-2 bg-red bg-1 bg-overlay-black-70 page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6 item">
              <div className="counter-block text-start mb-lg-0 mb-4">
                <div className="separator"></div>
                <div className="info">
                  <h6 className="text-white">Parked</h6>
                  <i className="glyph-icon flaticon-beetle"></i>
                  <b className="timer text-white" data-to="561" data-speed="3000">561</b>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 item">
              <div className="counter-block text-start mb-lg-0 mb-4">
                <div className="separator"></div>
                <div className="info">
                  <h6 className="text-white">Rated</h6>
                  <i className="glyph-icon flaticon-interface"></i>
                  <b className="timer text-white" data-to="856" data-speed="3000">856</b>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 item">
              <div className="counter-block text-start mb-sm-0 mb-4">
                <div className="separator"></div>
                <div className="info">
                  <h6 className="text-white">Trusted</h6>
                  <i className="glyph-icon flaticon-circle"></i>
                  <b className="timer text-white" data-to="789" data-speed="3000">789</b>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 item">
              <div className="counter-block text-start mb-0">
                <div className="separator"></div>
                <div className="info">
                  <h6 className="text-white">Served</h6>
                  <i className="glyph-icon flaticon-cup"></i>
                  <b className="timer text-white" data-to="356" data-speed="3000">356</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="testimonial-3 white-bg page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span>What Our Happy Clients say about us</span>
                <h2>Our Testimonial</h2>
                <div className="separator"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="owl-carousel owl-theme" data-nav-dots="true" data-items="1" data-md-items="1" data-sm-items="1" data-xs-items="1" data-space="15">
                <div className="item">
                  <div className="testimonial-block">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <div className="testimonial-avtar">
                          <img className="img-fluid center-block" src="images/team/01.jpg" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-9 col-sm-9">
                        <div className="testimonial-content">
                          <p><i className="fa fa-quote-left"></i> <span>The team handled everything professionally from the moment I arrived. The drop-off was quick, and the return was even faster. It made a great impression on our guests, and I didn't have to worry about parking for a single second during the event.</span> <i className="fa fa-quote-right float-end"></i></p>
                        </div>
                        <div className="testimonial-info">
                          <h6>Hamad Al-Mansoori</h6>
                          <span>Customer</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial-block">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <div className="testimonial-avtar">
                          <img className="img-fluid center-block" src="images/team/01.jpg" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-9 col-sm-9">
                        <div className="testimonial-content">
                          <p><i className="fa fa-quote-left"></i> <span>I've used valet services before, but this one stood out. The staff was polite, they noted all details carefully, and the car was returned exactly where I asked. Smooth process throughout, and that really helped me stay focused on the event.</span> <i className="fa fa-quote-right float-end"></i></p>
                        </div>
                        <div className="testimonial-info">
                          <h6>Sara Al-Naemi</h6>
                          <span>Customer</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="testimonial-block">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-sm-3">
                        <div className="testimonial-avtar">
                          <img className="img-fluid center-block" src="images/team/01.jpg" alt="" />
                        </div>
                      </div>
                      <div className="col-lg-9 col-md-9 col-sm-9">
                        <div className="testimonial-content">
                          <p><i className="fa fa-quote-left"></i> <span>Service was well-organized and quick. I dropped my car, shared my number, and got a clear ticket with a QR. Requested it later, and it was brought right to me without delay. Everything felt controlled and easy without any unnecessary steps.</span> <i className="fa fa-quote-right float-end"></i></p>
                        </div>
                        <div className="testimonial-info">
                          <h6>Fahad Al-Kuwari</h6>
                          <span>Customer</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default About;
